import Entity from './entity'
export default class PackageType extends Entity<number>{
    name:string;
    maxHeight:number;
    maxWidth:number;
    maxDepth:number;
    priceRate:number;
    isActive:boolean;
  
}